const initialState = {
  signInMessage: "",
  notifications: [],
  invitationsNumber: 0,
  isNotificationFetching: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "setSignInMessage":
      return { ...state, signInMessage: action.value };
    case "setNotifications":
      return {
        ...state,
        notifications: action.value,
        isNotificationFetching: false
      };
    case "setInvitationsNumber":
      return { ...state, invitationsNumber: action.value };
    case "setIsFetching":
      return { ...state, isNotificationFetching: action.value };
    case "addNotification":
      return {
        ...state,
        notifications: [...state.notifications, action.value],
        invitationsNumber: state.invitationsNumber + 1
      };
    default:
      return state;
  }
}
